import { CapoPlugin } from "/Users/infamus/Projects/compass_app/compass_frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];